export default __webpack_public_path__ + "ef8d0843c37cecdcb42334698ae0ddea.svg";